import { useNavigation } from '@/hooks/useNavigation';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import PromptService from '../../../services/prompt-service';
import { CreatePromptPayload, PromptData } from '../../../types/agent';

interface UseCreateOrUpdatePromptOptions {
  promptSlug?: string;
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
  doNotRedirect?: boolean;
  successMessage?: string;
}

const useCreateOrUpdatePrompt = ({
  promptSlug,
  doNotRedirect = false,
  onSuccess,
  onError,
  successMessage,
}: UseCreateOrUpdatePromptOptions) => {
  const { navigateToTenantRoute } = useNavigation();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      id,
      data,
    }: {
      id?: string | null;
      data: CreatePromptPayload;
      doNotRedirect?: boolean;
    }) => {
      if (id) {
        const response = await PromptService.updatePrompts(parseInt(id), data);
        return response as PromptData;
      } else {
        const response = await PromptService.createPrompts(data);
        return response as PromptData;
      }
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['agents'] });

      const message =
        successMessage ??
        (promptSlug || doNotRedirect
          ? 'Prompt updated successfully'
          : 'Prompt created successfully');
      toast.success(message, { position: 'top-right' });

      // TODO : move this out of query as these are side effects
      if (window.location.pathname.includes('/edit') || doNotRedirect) {
        onSuccess?.();
      } else {
        navigateToTenantRoute(`/agents/${data.id}/edit`);
      }

      // if (promptSlug || doNotRedirect) {
      //   onSuccess?.();
      // } else {
      //   navigate(`/agents/${data.id}/edit`);
      // }
    },
    onError: (error) => {
      if (onError) {
        onError(error);
        return;
      }

      const action = promptSlug ? 'update' : 'create';
      toast.error(`Failed to ${action} prompt. Please try again.`);
      console.error(`Failed to ${action} prompt:`, error);
    },
  });
};

export default useCreateOrUpdatePrompt;
